import { Component, OnInit } from "@angular/core";
import { FormGroup, Validators } from "@angular/forms";

import { MemberappBaseComponent } from "../memberapp-base/memberapp-base.component";
import { MembershipDetails } from "../../../shared/models";
import { MemberType, NotificationStatus } from "../../../shared/enums/data.enums";
import { distinctUntilChanged } from "rxjs/operators";
import { ACEPMembershipType, ACEPMembershipStatus, MembershipRate } from "src/app/shared/enums/xrm.constants";

@Component({
  selector: "app-membership",
  templateUrl: "./membership.component.html",
  styleUrls: ["./membership.component.scss"]
})
export class MembershipComponent extends MemberappBaseComponent {
  MemberType: typeof MemberType = MemberType;
  membershipDetails: MembershipDetails;
  membershipForm: FormGroup;
  currentMemberType: MemberType;
  age: number = -1;
  isInternationalMember: boolean = false;
  isUSOrCanadaMember: boolean = false;
  memberTypeClassNames: string = "col-md-3";
  memberTypeFirstClassNames: string = "col-md-3";


  get memberType() {
    return this.membershipForm.get("memberType");
  }
  get activeMilitary() {
    return this.membershipForm.get("activeMilitary");
  }
  get emResidencyTrained() {
    return this.membershipForm.get("emResidencyTrained");
  }
  get startEMBefore2000() {
    return this.membershipForm.get("startEMBefore2000");
  }
  get attest() {
    return this.membershipForm.get("attest");
  }
  get isRetiredMember(): boolean {
    //pga: coding-5865 changed condition to check member is from US or Canada and membertype is Regular or International
    //If Age > 55 And US or Canand Members And MemberType = Regular or International and Non restaring member
    //pga: coding-15947 added the active condition to check the retired contact
    const memberTypeRegOrInt = this.memberAppDataService.memberAppData.profile.allMemberships?.
    filter(m => (m.MemberType == ACEPMembershipType.Regular || m.MemberType == ACEPMembershipType.International)
        && m.MemberStatus == ACEPMembershipStatus.Active);
    return (this.age >= this.personalInfoService.retireAge && this.isUSOrCanadaMember && this.memberAppDataService.memberAppData.notifyInfo.status != NotificationStatus.ReadyToRestart && (memberTypeRegOrInt && memberTypeRegOrInt.length > 0));
  }

  ngOnInit() {
    //this.loggerService.logInfo(this.memberAppDataService.memberAppData);

    //reset
    this.resetForm();
    // https://stackoverflow.com/questions/47821809/rangeerror-maximum-call-stack-size-exceeded-when-using-valuechanges-subscribe
    //subscribe
    this.subscriptions.push(
      this.memberType.valueChanges.pipe(distinctUntilChanged()).subscribe(value => {
        this.setValidatorsForPage();
      })
    );

    this.subscriptions.push(
      this.emResidencyTrained.valueChanges.pipe(distinctUntilChanged()).subscribe(value => {
        this.setValidatorsForPage();
      })
    );

    this.subscriptions.push(
      this.startEMBefore2000.valueChanges.pipe(distinctUntilChanged()).subscribe(value => {
        if (
          this.startEMBefore2000.value == false &&
          this.emResidencyTrained.value == false
        ) {
          this.memberAppDataService.notify(NotificationStatus.Ineligible);
        }
      })
    );
  }

  ngAfterViewInit() {
    super.ngAfterViewInit();
    this.memberAppDomService.initMembershipStyles();
  }

  resetForm() {
    this.age = this.personalInfoService.contactAge;
    this.membershipDetails = this.memberAppDataService.memberAppData.membershipDetails;
    this.currentMemberType =  this.memberAppDataService.memberAppData.membershipDetails.memberType;
    this.isInternationalMember = this.memberAppDataService.memberAppData.profile.IsInternational;
    this.isUSOrCanadaMember = this.memberAppDataService.memberAppData.profile.IsUSOrCanada;

    if(this.isRetiredMember) {
      this.memberTypeClassNames = 'lb col-half-offset';
      this.memberTypeFirstClassNames = 'lb';
    } else {
      this.memberTypeClassNames = 'col-md-3';
      this.memberTypeFirstClassNames = 'col-md-3';
    }

    this.membershipForm = this.fb.group({
      memberType: [
        this.membershipDetails ? this.membershipDetails.memberType : null,
        Validators.required
      ],
      activeMilitary: [
        this.membershipDetails ? this.membershipDetails.activeMilitary : null,
        Validators.required
      ],
      emResidencyTrained: [
        this.membershipDetails
          ? this.membershipDetails.emResidencyTrained
          : null
      ],
      startEMBefore2000: [
        this.membershipDetails ? this.membershipDetails.startEMBefore2000 : null
      ],
      attest: [false, Validators.compose(
        this.currentMemberType == MemberType.Retired
          ? [Validators.requiredTrue]
          : []
      )]
    });

    this.setValidatorsForPage();
  }

  //pga: hotfix-5637 Reset startEMBefore2000 flag value when emResidencyTrained flag answer is 'Yes'
  setValidationEM() {
    if (this.emResidencyTrained.value == true) {
      this.startEMBefore2000.setValue(null);
    }
    this.startEMBefore2000.updateValueAndValidity();
  }

  setValidation() {
    if (this.memberType.value == MemberType.Retired) {
      this.attest.setValidators([Validators.required]);
      this.activeMilitary.clearValidators();
      this.activeMilitary.setValue(false);
    } else {
      this.attest.clearValidators();
      this.activeMilitary.setValidators([Validators.required]);
    }

    //pga: hotfix-5637 Reset startEMBefore2000 flag value when the member type is changed
    this.startEMBefore2000.setValue(null);
    this.startEMBefore2000.updateValueAndValidity();

    this.attest.updateValueAndValidity();
  }

  setValidatorsForPage() {
    this.memberType.value == MemberType.Physician || this.memberType.value == MemberType.Retired
      ? this.emResidencyTrained.setValidators([Validators.required])
      : this.emResidencyTrained.clearValidators();
      //pga: hotfix-5637 Added startEMBefore2000 validation for Retired members as well as now we are showing this question for Retired members
    this.emResidencyTrained.value == false && (this.memberType.value == MemberType.Physician || this.memberType.value == MemberType.Retired) 
      ? this.startEMBefore2000.setValidators([Validators.required])
      : this.startEMBefore2000.clearValidators();

    if(this.isInternationalMember) {
      this.activeMilitary.clearValidators();
      this.activeMilitary.setValue(false);
      this.activeMilitary.updateValueAndValidity();
    }

    this.emResidencyTrained.updateValueAndValidity();
    this.startEMBefore2000.updateValueAndValidity();
  }

  prepareDataModel(): MembershipDetails {
    let p: MembershipDetails = Object.assign(
      {},
      this.membershipDetails,
      this.membershipForm.value
    ) as MembershipDetails;
    p.military.activeMilitary = p.activeMilitary;
    return p;
  }

  save() {
    super.onSave(this.membershipForm);
    this.memberAppDataService.membTypeSavedFromUI = this.memberType.value;

    if (this.membershipForm.valid) {
      if (this.membershipForm.dirty) {
        // Copy the form values over the product object values
        this.membershipDetails = this.prepareDataModel();
        this.loggerService.logInfo(this.membershipDetails);
        this.membershipService
          .saveMembershipDetails(this.membershipDetails, this.isRetiredMember)
          .subscribe(
            () => this.onSaveComplete(),
            (error: any) => {
              this.errorMessage = <any>error;
              super.onError();
            }
          );
      } else {
        this.onSaveComplete();
      }
    }
  }

  onSaveComplete() {
    this.memberAppDataService.memberAppData.membershipDetails = this.membershipDetails;
    this.globalDomOpsService.notify("Membership Information Updated");
    this.memberAppDataService.navigateToRoute("education");
  }
}
